<template>
    <div>
        <v-card class="pa-3">
            <v-card-title class="headline pl-0 pt-0">Match List</v-card-title>
            <v-layout row>
                <v-layout column xs6>
                    <v-layout row class="mb-2">
                        <div class="font-weight-medium width-150">
                            Person ID
                        </div>
                        <div v-if="person.personID">{{ person.personID }}</div>
                        <div
                            v-if="!person.personID"
                            class="text-danger font-weight-medium"
                        >
                            No Person ID
                            <span v-if="person.parentId">{{
                                "- UTA Account: " + person.parentId
                            }}</span>
                        </div>
                    </v-layout>
                    <v-layout row class="mb-2">
                        <div class="font-weight-medium width-150">
                            Name
                        </div>
                        <div>
                            {{ person.firstEnglish + " " + person.lastEnglish }}
                        </div>
                    </v-layout>
                    <v-layout row class="mb-2">
                        <div class="font-weight-medium width-150">
                            Hebrew Name
                        </div>
                        <div>
                            {{
                                person.titleHebrew +
                                    " " +
                                    person.firstHebrew +
                                    " " +
                                    person.lastHebrew +
                                    " " +
                                    person.suffixHebrew
                            }}
                        </div>
                    </v-layout>
                    <v-layout row class="mb-2">
                        <div class="font-weight-medium width-150">
                            Address
                        </div>
                        <div>
                            {{
                                person.address1 +
                                    " " +
                                    person.city +
                                    " " +
                                    person.state +
                                    " " +
                                    person.zip
                            }}
                        </div>
                    </v-layout>
                </v-layout>
                <v-layout column xs6>
                    <v-layout row class="mb-2">
                        <div class="font-weight-medium width-200">
                            Father
                        </div>
                        <div>{{ person.father }}</div>
                    </v-layout>
                    <v-layout row class="mb-2">
                        <div class="font-weight-medium width-200">
                            Father Address
                        </div>
                        <div>{{ person.fatherAddress }}</div>
                    </v-layout>
                    <v-layout row class="mb-2">
                        <div class="font-weight-medium width-200">
                            Father In Law
                        </div>
                        <div>{{ person.fatherInLaw }}</div>
                    </v-layout>
                    <v-layout row class="mb-2">
                        <div class="font-weight-medium width-200">
                            Father In Law Address
                        </div>
                        <div>{{ person.fatherInLawAddress }}</div>
                    </v-layout>

                    <v-layout row class="mb-2">
                        <div class="font-weight-medium width-200">
                            Tuition Status
                        </div>
                        <div>{{ tuitionAccountStatus }}</div>

                        <v-btn
                            class="my-0"
                            @click="openUpdateTuitionStatus"
                            flat
                            icon
                            color="success"
                            style="height: 24px"
                        >
                            <v-icon>mdi-pencil</v-icon>
                        </v-btn>
                    </v-layout>

                    <v-layout row class="mb-2">
                        <div class="font-weight-medium width-200">
                            Tuition Status Reason
                        </div>
                        <div>{{ tuitionAccountStatusReason }}</div>
                    </v-layout>
                    <!-- <v-layout row class="mb-2">
                        <div class="font-weight-medium width-200">
                            Account Status
                        </div>
                        <div>{{ accountStatus }}</div>
                    </v-layout> -->
                    <!-- <v-layout row class="mb-2">
                        <div class="font-weight-medium width-200">
                            Account Status Note
                        </div>
                        <div>{{ accountStatusNote }}</div>
                    </v-layout> -->
                </v-layout>
            </v-layout>
            <v-layout row class="mb-2">
                <div class="font-weight-medium width-150">
                    Phone Numbers
                </div>
                <div>{{ person.phone }}</div>
            </v-layout>
            <v-divider class="mt-3"></v-divider>
            <v-tabs v-model="activeTab" hide-slider>
                <v-tabs-slider color="success"></v-tabs-slider>
                <v-tab
                    href="#matches"
                    v-bind:class="{
                        'selected-tab': activeTab == 'matches',
                    }"
                    >MATCHES ({{ matches.length }})</v-tab
                >
                <v-tab
                    href="#students"
                    v-bind:class="{
                        'selected-tab': activeTab == 'students',
                    }"
                    >STUDENTS ({{ students.length }})</v-tab
                >
                <v-tab
                    href="#notes"
                    v-bind:class="{
                        'selected-tab': activeTab == 'notes',
                    }"
                    >NOTES ({{ getNotes().length }})</v-tab
                >
                <v-tab
                    href="#reg-forms"
                    v-bind:class="{
                        'selected-tab': activeTab == 'reg-forms',
                    }"
                    >Registration Forms ({{ regForms.length }})</v-tab
                >
                <v-tab
                    href="#auto-matches"
                    v-bind:class="{
                        'selected-tab': activeTab == 'auto-matches',
                    }"
                    >Pending Auto Matches ({{
                        pendingAutoMatches.length
                    }})</v-tab
                >
                <v-spacer></v-spacer>
                <div class="font-weight-medium mr-1 pt-2">Status:</div>
                <div class="pt-2">
                    {{ accountStatus }}
                </div>
                <div
                    :title="accountStatusNote"
                    style="padding-top: 11px !important;"
                    class="caption ml-2"
                    v-if="accountStatusNote"
                >
                    {{ "(" + truncate(accountStatusNote, 30) + ")" }}
                </div>
                <v-btn
                    class="my-0"
                    @click="openUpdateStatus"
                    flat
                    icon
                    color="success"
                >
                    <v-icon>mdi-pencil</v-icon>
                </v-btn>
                <!-- <v-btn
                    color="success"
                    class="mr-1"
                    small
                    @click="openUpdateStatus"
                    >Update Status</v-btn
                > -->
            </v-tabs>
            <v-tabs-items v-model="activeTab">
                <v-tab-item value="matches">
                    <v-btn
                        color="success"
                        class="mr-1"
                        small
                        @click="openAddMatch"
                        :disabled="isDisabled()"
                        >Add Match</v-btn
                    >
                    <v-btn
                        v-if="selectedMatches.length"
                        color="success"
                        small
                        @click="openDeleteMatch"
                        >Delete Matches</v-btn
                    >
                    <v-data-table
                        v-model="selectedMatches"
                        :headers="matchHeaders"
                        :items="matches"
                        item-key="id"
                        class="elevation-0"
                        hide-actions
                    >
                        <template v-slot:items="props">
                            <tr
                                :active="props.selected"
                                @click="props.selected = !props.selected"
                            >
                                <td>
                                    <v-checkbox
                                        :input-value="props.selected"
                                        color="success"
                                        primary
                                        hide-details
                                    ></v-checkbox>
                                </td>
                                <td>
                                    <a
                                        @click.stop="openMatchInfo(props.item)"
                                        class=""
                                        >{{ props.item.doeID }}</a
                                    >
                                </td>
                                <td>
                                    {{ props.item.first }}
                                </td>
                                <td>
                                    {{ props.item.last }}
                                </td>
                                <td>
                                    {{ props.item.address }}
                                </td>
                                <td>
                                    {{ props.item.dob | date }}
                                </td>
                                <td>
                                    {{ props.item.datE_REG | date }}
                                </td>
                                <td>{{ props.item.matchType }}</td>
                                <td>
                                    <v-icon
                                        class=""
                                        dark
                                        :color="
                                            props.item.verified
                                                ? 'success'
                                                : 'danger'
                                        "
                                        >{{
                                            props.item.verified
                                                ? "mdi-check-circle"
                                                : "mdi-close"
                                        }}</v-icon
                                    >
                                </td>
                            </tr>
                        </template>
                    </v-data-table>
                </v-tab-item>
                <v-tab-item value="students">
                    <v-data-table
                        v-model="selectedStudents"
                        :headers="studentHeaders"
                        :items="students"
                        item-key="id"
                        class="elevation-0 mt-2"
                        hide-actions
                    >
                        <template v-slot:items="props">
                            <tr
                                :active="props.selected"
                                @click="props.selected = !props.selected"
                            >
                                <!-- <td>
                                        <v-checkbox
                                            :input-value="props.selected"
                                            color="success"
                                            primary
                                            hide-details
                                        ></v-checkbox>
                                    </td> -->
                                <td>
                                    <a
                                        @click.stop="
                                            openStudentInfo(props.item)
                                        "
                                        class=""
                                        >{{ props.item.id }}</a
                                    >
                                </td>
                                <td>
                                    {{ props.item.first }}
                                </td>
                                <td>
                                    {{ props.item.last }}
                                </td>
                                <td>
                                    {{ props.item.address1 }}
                                </td>
                                <td>
                                    {{ props.item.dob | date }}
                                </td>
                                <td>
                                    {{ props.item.source }}
                                </td>
                                <td>{{ props.item.branch }}</td>
                                <td>{{ props.item.status }}</td>
                                <!-- <td>
                                        <v-icon
                                            class=""
                                            dark
                                            :color="
                                                props.item.verified
                                                    ? 'success'
                                                    : 'danger'
                                            "
                                            >{{
                                                props.item.verified
                                                    ? "mdi-check-circle"
                                                    : "mdi-close"
                                            }}</v-icon
                                        >
                                    </td> -->
                            </tr>
                        </template>
                    </v-data-table>
                </v-tab-item>
                <v-tab-item value="notes">
                    <notes
                        v-if="person.personID"
                        :accountID="person.personID"
                        typeID="VOTE_REG"
                        type="VOTE_REG"
                        ref="notes"
                        :isExpanded="true"
                        :hideHeader="true"
                        :showCommunicationType="true"
                    ></notes>
                </v-tab-item>
                <v-tab-item value="reg-forms">
                    <v-btn
                        color="success"
                        class="mr-1"
                        small
                        @click="openAddRegistrationForm()"
                        :disabled="isDisabled()"
                        >Add Registration Form</v-btn
                    >
                    <v-data-table
                        :headers="regFormsHeaders"
                        :items="regForms"
                        item-key="id"
                        class="elevation-0 mt-2"
                        hide-actions
                    >
                        <template v-slot:items="props">
                            <tr
                                style="cursor: pointer;"
                                :active="props.selected"
                                @click="openAddRegistrationForm(props.item)"
                            >
                                <td>
                                    {{ props.item.name }}
                                </td>
                                <td>
                                    {{ props.item.type }}
                                </td>
                                <td>
                                    {{ props.item.address }}
                                </td>
                                <td>
                                    {{ props.item.dob | date }}
                                </td>
                                <td>
                                    {{ props.item.status }}
                                </td>
                                <td>{{ truncate(props.item.note, 35) }}</td>
                                <td>
                                    {{ props.item.dateSubmitted | date }}
                                </td>
                                <td>
                                    {{ props.item.enteredBy }}
                                </td>
                                <td>{{ props.item.enteredOn | date }}</td>
                            </tr>
                        </template>
                    </v-data-table>
                </v-tab-item>
                <v-tab-item value="auto-matches">
                    <v-data-table
                        :headers="autoMatchHeaders"
                        :items="pendingAutoMatches"
                        item-key="id"
                        class="elevation-0 mt-2"
                        hide-actions
                    >
                        <template v-slot:items="props">
                            <tr
                                @click="openUpdateAutoMatch(props.item)"
                                style="cursor: pointer;"
                            >
                                <td>
                                    <a
                                        @click.stop="openMatchInfo(props.item)"
                                        class=""
                                        >{{ props.item.doeID }}</a
                                    >
                                </td>
                                <td>
                                    {{ props.item.first }}
                                </td>
                                <td>
                                    {{ props.item.last }}
                                </td>
                                <td>
                                    {{ props.item.dob | date }}
                                </td>
                                <td>{{ props.item.matchType }}</td>
                                <td>{{ props.item.status }}</td>
                                <td>{{ props.item.title }}</td>
                                <td>
                                    <v-icon
                                        class=""
                                        dark
                                        :color="
                                            props.item.status == 'Pending'
                                                ? 'rgb(253, 180, 0)'
                                                : 'success'
                                        "
                                        >{{
                                            props.item.status == "Pending"
                                                ? "mdi-clock"
                                                : "mdi-check-circle"
                                        }}</v-icon
                                    >
                                </td>
                            </tr>
                        </template>
                    </v-data-table>
                </v-tab-item>
            </v-tabs-items>

            <v-card-actions class="mr-2">
                <v-spacer></v-spacer>
                <v-btn color="default" dark @click="closeMatchDialog"
                    >Close</v-btn
                >
            </v-card-actions>
        </v-card>
        <v-dialog persistent v-model="addMatchDialog" max-width="1700">
            <v-card class="pa-3">
                <v-card-title
                    class="headline pl-2 py-0"
                    v-bind:class="{
                        'mb-2': clickedDOE && clickedDOE.first,
                        'mb-4': !clickedDOE || !clickedDOE.first,
                    }"
                >
                    Add Match
                </v-card-title>
                <div
                    style="border: #4caf50 2px solid;"
                    class="mb-5"
                    v-if="clickedDOE && clickedDOE.first"
                >
                    <div
                        class="px-2"
                        style="background-color: #4caf50; color: #fff; width: fit-content;"
                    >
                        SELECTED:
                    </div>
                    <div class="pt-2 px-2 pb-1">
                        <v-layout class="mb-2 pl-2">
                            <div class="width-200 font-weight-medium">
                                Name
                            </div>
                            <div>
                                <span class="font-weight-regular mr-2"
                                    >({{
                                        clickedDOE.s == "M" ? "MALE" : "FEMALE"
                                    }})</span
                                >{{ clickedDOE.first + " " + clickedDOE.last }}
                            </div>
                        </v-layout>
                        <v-layout class="mb-2 pl-2">
                            <div class="width-200 font-weight-medium">
                                Address
                            </div>
                            <div>
                                {{
                                    clickedDOE.house +
                                        " " +
                                        clickedDOE.street +
                                        " " +
                                        clickedDOE.apt
                                }}
                            </div>
                        </v-layout>
                        <v-layout class="mb-2 pl-2">
                            <!-- <v-checkbox
                                v-model="clickedDOE.verified"
                                class="my-0 pt-2"
                                hide-details
                                color="success"
                                label="Verified"
                                style="max-width: 110px;"
                            ></v-checkbox> -->
                            <v-select
                                v-model="clickedDOE.matchType"
                                class="my-0 pt-2"
                                style="max-width: 150px;"
                                label="Match Type"
                                :items="['Husband', 'Wife', 'Daughter', 'Son']"
                                hide-details
                            >
                            </v-select>
                        </v-layout>
                        <!-- <v-layout class="mb-2 pl-2">
                            <v-checkbox
                                v-model="clickedDOE.addressMatch"
                                class="my-0 pt-2"
                                color="success"
                                style="max-width: 170px;"
                                label="Address Match"
                                hide-details
                            ></v-checkbox>
                            <v-checkbox
                                v-model="clickedDOE.phoneMatch"
                                color="success"
                                style="max-width: 200px;"
                                label="Phone Match"
                                class="my-0 pt-2"
                                hide-details
                            ></v-checkbox>
                        </v-layout> -->
                    </div>
                </div>

                <div v-if="showDoeGrid">
                    <data-grid
                        class="simple-datagrid pr-0 doe-table"
                        :url="doeUrl"
                        :dontSaveFilters="true"
                        :hideHeader="true"
                        :perPage="6"
                        :columns="doeColumns"
                        title="DOE"
                        ref="doeGrid"
                        :beforeSetupGrid="beforeSetupDoeGrid"
                        navigationPath="onSearchDOERowClicked"
                        navigationField="onSearchDOERowClicked"
                        v-bind:hideActions="true"
                        :onRowClicked="onSearchDOERowClicked"
                        :sortOptions="{
                            enabled: true,
                            field: 'last',
                            type: 'asc',
                        }"
                    ></data-grid>
                </div>
                <v-card-actions class="mr-0 pb-0">
                    <v-spacer></v-spacer>
                    <v-btn color="default" dark @click="closeAddMatchDialog"
                        >Cancel</v-btn
                    >
                    <v-btn
                        :loading="processing"
                        color="success"
                        @click="saveMatch()"
                        >Add Match</v-btn
                    >
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog v-model="existingMatchesWarningDialog" max-width="400">
            <v-card class="pa-3">
                <v-card-title class="headline text-warning pl-0 pt-0">
                    Are you sure?
                </v-card-title>
                <div class="mb-3">
                    This person is already matched, Do you want to continue?
                </div>
                <v-card-actions class="mr-0 pb-0">
                    <v-spacer></v-spacer>
                    <v-btn
                        color="default"
                        dark
                        @click="existingMatchesWarningDialog = false"
                        >Cancel</v-btn
                    >
                    <v-btn color="success" @click="addMatch()">Continue</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog v-model="deleteMatchDialog" max-width="400">
            <v-card class="pa-3">
                <v-card-title class="headline pl-0 pt-0">
                    Are you sure?
                </v-card-title>
                <div class="mb-3">This will delete the selected matches</div>
                <v-card-actions class="mr-0 pb-0">
                    <v-spacer></v-spacer>
                    <v-btn
                        color="default"
                        dark
                        @click="deleteMatchDialog = false"
                        >Cancel</v-btn
                    >
                    <v-btn color="success" @click="deleteMatches()"
                        >Delete</v-btn
                    >
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog v-model="matchInfoDialog" max-width="1000">
            <v-card v-if="clickedMatchDoe" class="pa-3">
                <doe-match-info
                    :row="clickedMatchDoe"
                    :columns="doeColumns"
                ></doe-match-info>
                <v-card-actions class="mr-0 pb-0">
                    <v-spacer></v-spacer>
                    <v-btn color="default" dark @click="matchInfoDialog = false"
                        >Close</v-btn
                    >
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog v-model="infoDialog" max-width="1000">
            <v-card v-if="clickedDOE" class="pa-3">
                <doe-match-info
                    :row="clickedDOE"
                    :columns="doeColumns"
                ></doe-match-info>
                <v-card-actions class="mr-0 pb-0">
                    <v-spacer></v-spacer>
                    <v-btn color="default" dark @click="infoDialog = false"
                        >Close</v-btn
                    >
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog v-model="updateTuitionStatusDialog" max-width="400">
            <v-card class="pa-3">
                <v-card-title class="headline pt-0 pb-2 pl-0">
                    Update Tuition Status
                </v-card-title>

                <v-select
                    :items="tuitionAccountStatuses"
                    v-model="tuitionAccountStatus"
                    label="Tuition Account Status"
                    clearable
                ></v-select>

                <v-textarea
                    v-model="tuitionAccountStatusReason"
                    label="Reason"
                    rows="2"
                ></v-textarea>
                <v-card-actions class="mr-0 pb-0">
                    <v-spacer></v-spacer>
                    <v-btn color="default" dark @click="closeUpdateStatus()"
                        >Cancel</v-btn
                    >
                    <v-btn
                        color="success"
                        :loading="processing"
                        @click="saveAccountStatus()"
                        >Save</v-btn
                    >
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog v-model="updateStatusDialog" max-width="400">
            <v-card class="pa-3">
                <v-card-title class="headline pt-0 pb-2 pl-0">
                    Update Status
                </v-card-title>
                <v-select
                    :items="accountStatuses"
                    v-model="accountStatus"
                    label="Account Status"
                    clearable
                ></v-select>
                <v-textarea
                    v-model="accountStatusNote"
                    label="Note"
                    rows="2"
                ></v-textarea>
                <v-card-actions class="mr-0 pb-0">
                    <v-spacer></v-spacer>
                    <v-btn color="default" dark @click="closeUpdateStatus()"
                        >Cancel</v-btn
                    >
                    <v-btn
                        color="success"
                        :loading="processing"
                        @click="saveAccountStatus()"
                        >Save</v-btn
                    >
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog persistent v-model="addRegFormDialog" max-width="400">
            <voting-reg-form
                ref="regFormDialog"
                :form="clickedRegForm"
                :person="person"
                :reload="loadRegForms"
                :close="closeAddRegistrationForm"
            ></voting-reg-form>
        </v-dialog>
        <v-dialog scrollable v-model="updateAutoMatchDialog" max-width="400">
            <v-card class="pa-2">
                <v-card-title class="headline px-2"
                    >Update Person -
                    {{ clickedAutoMatch.personID }}</v-card-title
                >

                <div class="px-2 mt-2">
                    <v-layout row class="mb-2">
                        <div class="font-weight-medium">
                            {{
                                clickedAutoMatch.first +
                                    " " +
                                    clickedAutoMatch.last +
                                    " (" +
                                    getGander(clickedAutoMatch) +
                                    ")"
                            }}
                        </div>
                    </v-layout>
                    <v-layout row class="mb-2">
                        <div class="font-weight-medium width-150">Address</div>
                        <div>
                            {{ getAddress(clickedAutoMatch) }}
                        </div>
                    </v-layout>
                    <v-layout row class="mb-2">
                        <div class="font-weight-medium width-150">
                            City:
                        </div>
                        <div>{{ clickedAutoMatch.city }}</div>
                    </v-layout>
                    <v-layout row class="mb-2">
                        <div class="font-weight-medium width-150">
                            Zip:
                        </div>
                        <div>{{ clickedAutoMatch.zip }}</div>
                    </v-layout>
                    <v-layout row class="mb-2">
                        <div class="font-weight-medium width-150">
                            DOB:
                        </div>
                        <div>{{ clickedAutoMatch.dob | date }}</div>
                    </v-layout>
                    <v-layout
                        row
                        class="mb-2"
                        v-if="clickedAutoMatch.autoMatchType == 'STUDENT'"
                    >
                        <div class="font-weight-medium width-150">
                            ANSL Name:
                        </div>
                        <div>{{ clickedAutoMatch.anslName }}</div>
                    </v-layout>
                    <v-layout
                        row
                        class="mb-2"
                        v-if="clickedAutoMatch.autoMatchType == 'STUDENT'"
                    >
                        <div class="font-weight-medium width-150">
                            ANSL Address:
                        </div>
                        <div>{{ clickedAutoMatch.anslAddress }}</div>
                    </v-layout>
                    <v-divider class="my-2 pb-2"></v-divider>
                    <v-select
                        v-if="clickedAutoMatch.autoMatchType == 'FAMILY'"
                        class="pt-3"
                        :items="[
                            'Husband',
                            'Wife',
                            'Daughter',
                            'Son',
                            'Not Matched',
                        ]"
                        label="Match Type"
                        v-model="clickedAutoMatch.matchType"
                        clearable
                        ref="matchType"
                        :rules="[rules.required]"
                        @change="matchTypeChanged"
                    ></v-select>
                </div>
                <v-card-actions class="pt-3 mr-2 mt-3 pb-2">
                    <v-spacer></v-spacer>
                    <v-btn
                        dark
                        color="default"
                        @click="updateAutoMatchDialog = false"
                        >Cancel</v-btn
                    >
                    <v-btn
                        :loading="processing"
                        dark
                        color="success"
                        @click="saveAutoMatch"
                    >
                        Save
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import { truncate } from "../../utils/helpers.js";
import DoeMatchInfo from "./DoeMatchInfo.vue";
import votingRegForm from "./VotingRegForm.vue";
import notes from "../components/Notes.vue";

export default {
    components: {
        DoeMatchInfo,
        votingRegForm,
        notes,
    },
    props: {
        person: Object,
        reload: Function,
        close: Function,
    },
    data: () => ({
        title: "Master List",
        matchDialog: false,
        deleteMatchDialog: false,
        addMatchDialog: false,
        infoDialog: false,
        matchInfoDialog: false,
        existingMatchesWarningDialog: false,
        clickedDOE: {},
        clickedMatchDoe: {},
        selectedMatches: [],
        matches: [],
        students: [],
        selectedStudents: [],
        userID: "",
        processing: false,
        showDoeGrid: false,
        url: "",
        doeUrl: "doe",
        actions: [],
        phoneSearch: "",
        activeTab: "matches",

        updateStatusDialog: false,
        updateTuitionStatusDialog: false,
        accountStatus: "",
        tuitionAccountStatus: "",
        tuitionAccountStatusReason: "",
        accountStatusNote: "",
        accountStatuses: [
            "Registered",
            "Don’t Want To Registrar",
            "Waiting For Application",
            "Received Application ",
        ],

        tuitionAccountStatuses: ["Bypass"],

        regForms: [],
        pendingAutoMatches: [],
        updateAutoMatchDialog: false,
        clickedAutoMatch: {},
        addRegFormDialog: false,
        clickedRegForm: {},

        rules: {
            required: (value) => !!value || "Required.",
        },

        matchHeaders: [
            {
                text: "",
                value: "",
            },
            {
                text: "DOE ID",
                value: "doeID",
            },
            { text: "First", value: "first" },
            { text: "Last", value: "last" },
            { text: "Address", value: "address" },
            { text: "DOB", value: "dob" },
            { text: "Registered On", value: "datE_REG" },
            { text: "Match Type", value: "matchType" },
            { text: "Verified", value: "verified" },
        ],

        doeColumns: [
            {
                field: "isMatched",
                isIcon: true,
                icon: (value) => {
                    return value ? "mdi-check-circle" : "mdi-alert";
                },
                iconColor: (value) => {
                    return value ? "success" : "#f35123";
                },
            },
            {
                label: "ID",
                field: "reG_ID",
                sortable: true,
                hidden: false,
                showLink() {
                    return true;
                },
                filterOptions: {
                    enabled: true,
                    filterValue: "",
                    placeholder: "",
                },
            },
            {
                label: "First",
                field: "first",
                sortable: true,
                hidden: false,
                filterOptions: {
                    enabled: true,
                    filterValue: "",
                    placeholder: "",
                },
            },
            {
                label: "Last",
                field: "last",
                sortable: true,
                hidden: false,
                filterOptions: {
                    enabled: true,
                    filterValue: "",
                    placeholder: "",
                },
            },
            {
                label: "Gander",
                field: "s",
                sortable: true,
                width: "50px",
                hidden: false,
                filterOptions: {
                    enabled: true,
                    placeholder: "",
                },
            },
            {
                label: "House",
                field: "house",
                sortable: true,
                hidden: false,
                filterOptions: {
                    enabled: true,
                    filterValue: "",
                    placeholder: "",
                },
            },
            {
                label: "Street",
                field: "street",
                sortable: true,
                width: "250px",
                hidden: false,
                filterOptions: {
                    enabled: true,
                    filterValue: "",
                    placeholder: "",
                },
            },
            {
                label: "Apt",
                field: "apt",
                sortable: true,
                width: "50px",
                hidden: false,
                filterOptions: {
                    enabled: true,
                    placeholder: "",
                },
            },
            {
                label: "City",
                field: "city",
                sortable: true,
                hidden: false,
                filterOptions: {
                    enabled: true,
                    placeholder: "",
                },
            },
            {
                label: "Zip",
                field: "zip",
                sortable: true,
                hidden: false,
                filterOptions: {
                    enabled: true,
                    placeholder: "",
                },
            },
            {
                sortable: true,
                label: "Matched",
                field: "isMatched",
                type: "boolean",
                formatFn: (value, row) => {
                    return row.isMatched ? "Yes" : "No";
                },
                hidden: false,
                filterOptions: {
                    enabled: true,
                    placeholder: "Select",
                    filterDropdownItems: [
                        { value: true, text: "Yes" },
                        { value: false, text: "No" },
                    ],
                },
            },
            {
                label: "Matched To",
                field: "matchName",
                width: "250px",
                sortable: true,
                hidden: false,
                filterOptions: {
                    enabled: true,
                    placeholder: "",
                },
            },
            {
                label: "DOB",
                field: "dob",
                sortable: true,
                hidden: false,
                filterOptions: {
                    enabled: true,
                    placeholder: "",
                },
            },
        ],

        studentHeaders: [
            // { text: "", value: "" },
            { text: "ID", value: "id" },
            { text: "First", value: "first" },
            { text: "Last", value: "last" },
            { text: "Address", value: "address1" },
            { text: "DOB", value: "dob" },
            { text: "Source", value: "source" },
            { text: "Branch", value: "branch" },
            { text: "Status", value: "status" },
        ],

        regFormsHeaders: [
            { text: "Name", value: "name" },
            { text: "Type", value: "type" },
            { text: "Address", value: "address" },
            { text: "DOB", value: "dob" },
            { text: "Status", value: "status" },
            { text: "Note", value: "note" },
            { text: "Date Submitted", value: "dateSubmitted" },
            { text: "Entered By", value: "enteredBy" },
            { text: "Entered On", value: "enteredOn" },
        ],

        autoMatchHeaders: [
            {
                text: "",
                value: "",
            },
            { text: "Doe ID", value: "doeID" },
            { text: "First", value: "first" },
            { text: "Last", value: "last" },
            { text: "Match Type", value: "matchType" },
            { text: "DOB", value: "dob" },
            { text: "Auto Match", value: "title" },
        ],
    }),
    watch: {
        person(newValue, oldValue) {
            this.load(newValue);
        },
    },
    created() {
        if (this.person) {
            this.load(this.person);
        }
    },
    methods: {
        async load(person) {
            if (!person || !person.personID) {
                this.loadAccountStatus();

                return;
            }

            this.selectedMatches = [];

            await this.loadMatches(person.personID);

            const parents = await this.$http.post("api/voting/getParents", [
                person.paternalGrandParentId,
                person.maternalGrandParentId,
            ]);

            const students = await this.$http.get(
                "api/voting/GetStudents?personID=" + person.personID,
            );

            const father = parents.find(
                (p) => p.personID == person.paternalGrandParentId,
            );
            const fatherInLaw = parents.find(
                (p) => p.personID == person.maternalGrandParentId,
            );

            this.students = students;
            this.person.fatherAddress = father ? father.address1 : "";
            this.person.fatherInLawAddress = fatherInLaw
                ? fatherInLaw.address1
                : "";

            this.matchDialog = true;

            const regForms = await this.$http.get(
                "api/votingRegstrationFormStatus/getByID?personID=" +
                    person.personID,
            );

            this.regForms = regForms;

            const pendingAutoMatches = await this.$http.get(
                "api/votingRegistrationAutoMatch/GetPendingAutoMatches?personID=" +
                    person.personID,
            );

            this.pendingAutoMatches = pendingAutoMatches;

            this.loadAccountStatus();
        },
        async loadAccountStatus() {
            const accountSettings = await this.$http.get(
                "api/voting/GetAccountSettings?personID=" +
                    this.person.personID +
                    (this.person.parentId
                        ? "&accountID=" + this.person.parentId
                        : ""),
            );

            if (accountSettings) {
                this.accountStatus = accountSettings.accountStatus;
                this.accountStatusNote = accountSettings.note;
                this.tuitionAccountStatus =
                    accountSettings.tuitionAccountStatus;
                this.tuitionAccountStatusReason =
                    accountSettings.tuitionAccountStatusReason;
            } else {
                this.accountStatus = "";
                this.accountStatusNote = "";
                this.tuitionAccountStatus = "";
                this.tuitionAccountStatusReason = "";
            }
        },
        async loadMatches(personID) {
            const matches = await this.$http.get(
                "api/voting/getMatches?personID=" +
                    encodeURIComponent(personID),
            );

            this.matches = matches
                .filter((m) => !m.removed)
                .map((match) => {
                    match.address = match.house + " " + match.street;

                    return match;
                });
        },
        getNotes() {
            if (!this.$refs || !this.$refs.notes) return [];

            return this.$refs.notes.getNotes();
        },
        openDeleteMatch() {
            this.deleteMatchDialog = true;
        },
        openAddMatch() {
            this.addMatchDialog = true;
            this.showDoeGrid = true;
        },
        openAddRegistrationForm(row = null) {
            this.clickedRegForm = row ? row : {};
            this.addRegFormDialog = true;

            if (this.$refs.regFormDialog) {
                this.$refs.regFormDialog.resetValidation();
            }
        },
        closeAddRegistrationForm() {
            this.addRegFormDialog = false;
        },
        async loadRegForms() {
            this.regForms = await this.$http.get(
                "api/votingRegstrationFormStatus/getByID?personID=" +
                    this.person.personID,
            );

            this.reload();
        },
        closeMatchDialog() {
            this.close();

            this.activeTab = "matches";
        },
        isDisabled() {
            return !this.person.personID;
        },
        async openMatchInfo(row) {
            this.clickedMatchDoe = await this.$http.get(
                "api/voting/getDoe?id=" + row.doeID,
            );
            this.matchInfoDialog = true;
        },
        openUpdateStatus() {
            this.updateStatusDialog = true;
        },
        openUpdateTuitionStatus() {
            this.updateTuitionStatusDialog = true;
        },
        openUpdateAutoMatch(autoMatch) {
            this.clickedAutoMatch = JSON.parse(JSON.stringify(autoMatch));
            this.updateAutoMatchDialog = true;
        },
        matchTypeChanged(value) {
            if (!value) {
                this.clickedAutoMatch.status = "Pending";

                return;
            }

            if (value == "Not Matched") {
                this.clickedAutoMatch.status = value;
            } else {
                this.clickedAutoMatch.status = "Verified";
            }
        },
        getGander(person) {
            if (this.clickedAutoMatch.autoMatchType == "STUDENT") {
                return person.gander;
            }

            return person.s == "M"
                ? "Male"
                : person.s == "F"
                ? "Female"
                : "Undefined";
        },
        getAddress(person) {
            if (this.clickedAutoMatch.autoMatchType == "STUDENT") {
                return person.address1;
            }

            return person.house + " " + person.street + " " + person.apt;
        },
        async saveAutoMatch() {
            if (!this.$refs.matchType.validate(true)) return;

            this.processing = true;

            try {
                await this.$http.post("api/voting/UpdateMatchStatus", {
                    user: this.$store.state.authentication.user,
                    matches: [
                        {
                            status: this.clickedAutoMatch.status,
                            matchType: this.clickedAutoMatch.matchType,
                            personID: this.clickedAutoMatch.personID,
                            id: this.clickedAutoMatch.id,
                            doeID: this.clickedAutoMatch.doeID,
                            studentID: this.clickedAutoMatch.studentID,
                        },
                    ],
                });

                this.processing = false;

                this.$notify({
                    text: "Changes Saved",
                    group: "notification",
                    type: "success",
                });

                this.updateAutoMatchDialog = false;
                this.load(this.person);
                this.reload();
            } catch (e) {
                this.processing = false;
            }
        },
        closeUpdateStatus() {
            this.updateStatusDialog = false;
            this.updateTuitionStatusDialog = false;

            this.loadAccountStatus();
        },
        async saveAccountStatus() {
            if (this.tuitionAccountStatus && !this.tuitionAccountStatusReason) {
                return this.$notify({
                    group: "notification",
                    text: "Reason Required",
                    type: "error",
                });
            }

            try {
                this.processing = true;

                await this.$http.post("api/voting/saveAccountSettings", {
                    personID: this.person.personID,
                    accountID: this.person.parentId,
                    accountStatus: this.accountStatus,
                    note: this.accountStatusNote,
                    tuitionAccountStatus: this.tuitionAccountStatus,
                    tuitionAccountStatusReason: this.tuitionAccountStatusReason,
                });

                this.updateStatusDialog = false;
                this.updateTuitionStatusDialog = false;

                this.reload();
                this.processing = false;
            } catch (e) {
                this.processing = false;
            }
        },
        truncate(text, count) {
            return truncate(text, count);
        },
        openStudentInfo(row) {},
        beforeSetupDoeGrid() {
            this.doeColumns.find(
                (c) => c.field == "reG_ID",
            ).linkAction = this.openInfoDialog;

            this.doeColumns.find(
                (c) => c.field == "last",
            ).filterOptions.filterValue = this.person.lastEnglish.slice(0, 4);

            const houseNumber = this.person.address1.split(" ")[0];
            const street = this.person.address1.split(" ")[1];

            this.doeColumns.find(
                (c) => c.field == "house",
            ).filterOptions.filterValue = houseNumber
                ? houseNumber.slice(0, 4)
                : "";
            this.doeColumns.find(
                (c) => c.field == "street",
            ).filterOptions.filterValue = street ? street.slice(0, 4) : "";

            this.doeUrl = "doe";
        },
        closeAddMatchDialog() {
            this.doeColumns.find(
                (c) => c.field == "first",
            ).filterOptions.filterValue = "";
            this.doeColumns.find(
                (c) => c.field == "last",
            ).filterOptions.filterValue = "";
            this.doeColumns.find(
                (c) => c.field == "house",
            ).filterOptions.filterValue = "";
            this.doeColumns.find(
                (c) => c.field == "street",
            ).filterOptions.filterValue = "";

            this.showDoeGrid = false;
            this.addMatchDialog = false;
        },
        openInfoDialog(row) {
            this.clickedDOE = row;
            this.infoDialog = true;
        },
        async deleteMatches() {
            try {
                this.processing = true;

                await this.$http.post("api/voting/RemoveMatches", {
                    userID: this.$store.state.authentication.user,
                    ids: this.selectedMatches.map((m) => m.id),
                });

                this.$notify({
                    text: "Matches Deleted",
                    group: "notification",
                    type: "success",
                });

                this.processing = false;
                this.loadMatches(this.person.personID);
                this.reload();
                this.deleteMatchDialog = false;
            } catch (e) {
                this.processing = false;
            }
        },
        async saveMatch() {
            if (!this.clickedDOE || !this.clickedDOE.regID) {
                return this.$notify({
                    text: "Please select person",
                    group: "notification",
                    type: "error",
                });
            }
            if (!this.clickedDOE.matchType) {
                return this.$notify({
                    text: "Please select Match Type",
                    group: "notification",
                    type: "error",
                });
            }

            try {
                this.processing = true;

                const existingMatches = await this.$http.get(
                    "api/voting/GetMatchByDoeID?doeID=" + this.clickedDOE.regID,
                );

                if (existingMatches && existingMatches.length) {
                    this.processing = false;

                    this.existingMatchesWarningDialog = true;

                    return;
                }

                await this.addMatch();
            } catch (e) {
                this.processing = false;
            }
        },
        async addMatch() {
            try {
                this.processing = true;

                await this.$http.post("api/voting/addMatch", {
                    doeID: this.clickedDOE.regID,
                    personID: this.person.personID,
                    verified: this.clickedDOE.verified ? 2 : 0,
                    matchType: this.clickedDOE.matchType,
                    matchedByUserID: this.$store.state.authentication.user,
                    verifiedByUserID: this.$store.state.authentication.user,
                    phoneMatch: this.clickedDOE.phoneMatch ? 1 : null,
                    addressMatch: this.clickedDOE.addressMatch ? 1 : null,
                });

                this.$notify({
                    text: "Match Saved",
                    group: "notification",
                    type: "success",
                });

                this.processing = false;
                this.loadMatches(this.person.personID);
                this.reload();
                this.closeAddMatchDialog();
                this.existingMatchesWarningDialog = false;
            } catch (e) {
                this.processing = false;
            }
        },
        onSearchDOERowClicked(row) {
            this.clickedDOE = row;
            this.clickedDOE.matchType =
                this.clickedDOE.s == "M"
                    ? "Husband"
                    : this.clickedDOE.s == "F"
                    ? "Wife"
                    : "";
            this.clickedDOE.verified = true;
            this.clickedDOE.phoneMatch = false;
            this.clickedDOE.addressMatch = false;
        },
    },
};
</script>
<style>
.accounts-search.container {
    padding-top: 0px;
}
.doe-table .vgt-table th {
    padding: 0.2em 1.5em 0em 0.75em !important;
}
.doe-table table.vgt-table td {
    padding: 0.5em 0.75em 0.5em 0.75em !important;
}
.doe-table .table.vgt-table {
    font-size: 14px !important;
}
.doe-table .vgt-table th.filter-th {
    padding: 0.2em 0.75em 0.5em 0.75em !important;
}
.selected-tab {
    color: rgb(76, 175, 80) !important;
    border-bottom: 1px solid rgb(76, 175, 80) !important;
}
</style>
